import { alpha, Box, css, styled, Typography } from '@mui/material';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import { ReactComponent as ExpandArrow } from 'ui/assets/expand_arrow.svg';

const LegacyTypographyReset = styled(Typography)`
  margin: 0 !important;
`;

export const SideMenuItems = styled(Box, { name: 'SideMenuItems' })`
  ${({ theme }) => css`
    display: flex;
    background-color: ${theme.palette.transparent.white[4]};
    max-width: ${theme.spacing(31)};
    min-width: ${theme.spacing(31)};
    border-radius: ${theme.spacing(1)};
    flex-direction: column;
    margin-bottom: auto;
  `}
`;

export const SideMenuItem = styled(
  (props: AccordionProps) => <MuiAccordion disableGutters elevation={0} {...props} />,
  {
    name: 'SideMenuItem'
  }
)`
  ${({ theme }) => css`
    border-radius: ${theme.spacing(1)};
    overflow: hidden;
    background-color: transparent;

    &:before {
      opacity: 0;
    }

    &:not(.Mui-expanded):not(:last-of-type) {
      &:after {
        background-color: ${theme.palette.grey[500]};
        content: ' ';
        width: 100%;
        height: 1px;
        display: block;
      }
    }
  `}
`;

export const SideMenuHeader = styled(
  (props: AccordionSummaryProps) => <MuiAccordionSummary expandIcon={<ExpandArrow />} {...props} />,
  { name: 'SideMenuHeader' }
)`
  ${({ theme }) => css`
    min-height: ${theme.spacing(7.5)};
    max-height: ${theme.spacing(7.5)};
    padding: ${theme.spacing(1)};
    margin-right: ${theme.spacing(1)};

    background-color: ${alpha(theme.palette.common.black, 0.04)};
    border-radius: ${theme.spacing(1)};

    &.Mui-expanded {
      border-radius: ${theme.spacing(1, 1, 0, 0)};
    }

    & .MuiAccordionSummary-expandIconWrapper {
      transform: rotate(-90deg);
    }

    & .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
      transform: rotate(0);
    }

    & .MuiAccordionSummary-content {
      margin-left: ${theme.spacing(1.5)};
      display: flex;
      flex-flow: column;
      align-items: start;
    }
  `}
`;

export const SideMenuHeaderTitleText = styled(LegacyTypographyReset, { name: 'SideMenuHeaderTitleText' })`
  ${({ theme }) => css`
    color: ${theme.palette.grey[100]};
    font-size: ${theme.typography.h6.fontSize};
    line-height: ${theme.typography.h6.lineHeight};
  `}
`;

export const SideMenuHeaderTitle = styled(Box, { name: 'SideMenuHeaderTitle' })`
  ${() => css`
    display: flex;
    justify-content: center;
    align-items: center;
  `}
`;
export const SideMenuHeaderIcon = styled(Box, { name: 'SideMenuHeaderIcon' })`
  ${({ theme }) => css`
    display: flex;
    padding-right: ${theme.spacing(1)};
  `}
`;

export const SideMenuHeaderSubTitle = styled(LegacyTypographyReset, { name: 'SideMenuHeaderSubTitle' })`
  ${({ theme }) => css`
    color: ${theme.palette.grey[100]};
    font-size: ${theme.typography.subtitle2.fontSize};
    line-height: ${theme.typography.subtitle2.lineHeight};
  `}
`;

export const SideMenuSubItems = styled(Box, { name: 'SideMenuSubItems' })`
  ${({ theme }) => css`
    background-color: ${theme.palette.secondary.main};
  `}
`;

export const SideMenuSubItem = styled(Box, { name: 'SideMenuSubItem' })<{ selected: boolean }>`
  ${({ theme, selected }) => css`
    padding: ${theme.spacing(1.5, 1, 0)};
    cursor: pointer;
    background-color: ${selected ? theme.palette.transparent.primary[32] : theme.palette.transparent.white[4]};
    border-radius: ${selected ? theme.spacing(1) : 'unset'};

    &:last-of-type {
      margin-bottom: 0;
      border-bottom: unset;
    }

    &:hover {
      border-radius: ${theme.spacing(1)};
      background-color: ${selected ? theme.palette.transparent.primary[32] : theme.palette.grey[400]};
    }

    &:last-of-type > div {
      margin-bottom: 0;
      border-bottom: unset;
    }
  `}
`;

export const SideMenuSubItemContent = styled(Box, { name: 'SideMenuSubItemContent' })`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: ${theme.spacing(5.5)};
    border-bottom: 1px solid ${theme.palette.grey[500]};
    padding: ${theme.spacing(0, 1, 1)};
  `}
`;
